export default [
  {
    path: "/wssj",
    name: "wssj",
    component: (resolve) => require(["@/views/PCView/wssj/index.vue"], resolve),
  },
];
